<div class="login-page">
  <form class="login-card" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <!-- Brand -->
    <div class="brand">
      <picture>
        <source srcset="../../assets/logo_sm.jpg" media="(min-width: 300px) and (max-width: 576px)">
        <source srcset="../../assets/logo.jpg" media="(min-width: 576px)">
        <img src="../../assets/logo.jpg" alt="Labrador AI" class="brand-logo">
      </picture>
    </div>

    <h1 class="heading">Set a new password</h1>
    <p class="subheading">Choose a new password for your account.</p>

    <div class="field">
      <label for="password" class="field-label">New password</label>
      <input id="password" type="password" formControlName="password" class="field-input"
        [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder="••••••••"
        autocomplete="new-password">
    </div>

    <div class="field">
      <label for="confirmPassword" class="field-label">Confirm password</label>
      <input id="confirmPassword" type="password" formControlName="confirmPassword" class="field-input"
        [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" placeholder="••••••••"
        autocomplete="new-password">
    </div>

    <div *ngIf="error" class="alert">{{ error }}</div>

    <button type="submit" class="btn-primary" [disabled]="loading">
      <span *ngIf="!loading">Reset password</span>
      <span *ngIf="loading">Saving…</span>
    </button>

    <p class="back-hint">
      <a [routerLink]="['/login']">&#8592; Back to sign in</a>
    </p>
  </form>
</div>
